import React from "react";
import useUpdateEmailApi from "../../Global/Api/Settings/updateEmailApi";
import useEmailValidation from "../../Global/Hooks/emailValidation";
import Button from "../../UI/Button";
import Input from "../../UI/Input";
import Popup from "../Popup";

export default function EmailChangeModal({ setEmailModal, setCodeModal }) {
  const emailApi = useUpdateEmailApi();
  const newEmailValidation = useEmailValidation();

  const handleSubmitEmail = (event) => {
    event.preventDefault();
    emailApi.send(
      { email: newEmailValidation?.value },
      setEmailModal,
      setCodeModal
    );
  };

  const handleNewEmailChange = (event) => {
    newEmailValidation.handleChange(event);
    newEmailValidation.validateEmail(event.target.value);
  };

  const closeInfo = () => {
    setEmailModal(false);
  };

  const isButtonDisabled = !newEmailValidation.isValid;

  return (
    <Popup closePopup={closeInfo} title="Change email">
      <div className="personal__popup">
        <p className="personal__popup-text">
          We’ll send a verification code to this email
        </p>
        <form onSubmit={handleSubmitEmail} className="personal__form mt20">
          <div className="personal__popup-input">
            <Input
              label="New email"
              placeholder="Enter email"
              type="email"
              id="email"
              handleChange={handleNewEmailChange}
            />
          </div>
          <div className="personal__popup-btn">
            <Button disabled={isButtonDisabled} text="Send a code" />
          </div>
        </form>
      </div>
    </Popup>
  );
}
